import { z } from "zod";
import { IdSchema } from "./primitives.js";
/** A bounded, PHI-safe validation result that can cross process boundaries. */
export const ValidationIssueSchema = z
    .object({
    code: z.string().min(1).max(100),
    severity: z.enum(["warning", "error", "blocker"]),
    message: z.string().min(1).max(500),
    actionId: IdSchema.optional(),
    sourceIds: z.array(IdSchema).default([]),
})
    .strict();
//# sourceMappingURL=validation.js.map